export const getFormId = (kind: 'main' | 'sub', id: string) =>
  `general-errand-${kind}-${id}`;

export const GENERAL_ERRAND_DEFAULT_SETTINGS = {
  auto_forward_delegation_after_days: null,
  attempt_component_supplier_delegation: null,
  default_priority: 1,
  is_active: true,
  should_be_invoiced: true,
  allowed_in_portals: [0, 1, 2],
  allowed_connection_types: [
    // 'objects.building',
    'objects.apartment',
    // 'objects.brfapartment',
    'objects.industrialpremises',
    'objects.outdoorsection',
    'objects.parkingspot',
    'objects.commonarea',
    // 'objects.room',
    // 'objects.component',
    // 'accounting.invoice',
  ],
  description_configuration: [1, 3, 5],
  images_configuration: [0, 2, 4],
  film_recordings_configuration: [0, 2, 4],
  files_configuration: [0, 2, 4],
  address_configuration: [0, 2, 4],
  object_access_configuration: [],
  object_access_available_options: [],
  has_pets_configuration: [0, 2, 4],
  priority_configuration: [0],
  is_warranty_configuration: [0],
  object_connection_configuration: [1, 3],
  creator_ssn_org_no_configuration: [0, 2, 4],
  creator_first_name_configuration: [0, 2, 4],
  creator_last_name_configuration: [0, 2, 4],
  creator_phone_number_configuration: [0, 2, 4],
  creator_email_configuration: [0, 2, 5],
  reporter_ssn_org_no_configuration: [0, 2, 4],
  reporter_first_name_configuration: [0, 2, 4],
  reporter_last_name_configuration: [0, 2, 4],
  reporter_phone_number_configuration: [0, 2, 4],
  reporter_email_configuration: [0, 2, 4],
  temporary_contact_ssn_configuration: [0, 2, 4],
  temporary_contact_org_no_configuration: [0, 2, 4],
  temporary_contact_first_name_configuration: [0, 2, 4],
  temporary_contact_last_name_configuration: [0, 2, 4],
  temporary_contact_phone_number_configuration: [0, 2, 4],
  temporary_contact_email_configuration: [0, 2, 4],
  show_default_descriptions: null,
  general_information_view_configuration: [0],
  temporary_contact_view_configuration: [0, 2],
  sensitive_personal_information_view_configuration: [0],
  actions_view_configuration: [0],
  reporter_view_configuration: null,
  creator_view_configuration: null,
  performer_view_configuration: null,
  object_connection_view_configuration: null,
  id_number_prefix: 'F',
  id_number_date_format: 3,
  id_number_separator: '-',
  id_number_min_id_length: 3,
  id_number_start_number: 1,
  sub_type_configuration: [0, 2, 4],
  // segments: [],
  // realestates: [],
  // external_clients: [],
  // companies: [],
  default_actions: [],
  default_descriptions: [],
  auto_organization_user_reviewers: [],
  auto_external_supplier_reviewers: [],
  auto_work_engagement_reviewers: [],
};

export const GENERAL_ERRAND_STATUS = {
  CREATED: 0,
  ACCEPTED: 1,
  STARTED: 2,
  PAUSED: 3,
  COMPLETED: 4,
  COMPLETED_REPORTER: 5,
  ANNULLED: 6,
} as const;

export const GENERAL_ERRAND_PRIORITY = {
  LOW: 0,
  MEDIUM: 1,
  HIGH: 2,
  HIGHEST: 3,
} as const;

export const GENERAL_ERRAND_INVOICING_STATUS = {
  MISSING_COSTS: 0,
  PENDING_ERRAND_COST_DATA: 1,
  PENDING_INVOICE_CREATION: 2,
  PENDING_INVOICE_ATTEST: 3,
  PENDING_PARTLY_INVOICE_ATTEST: 4,
  ALL_INVOICES_ATTESTED: 5,
} as const;
